import api from '@/helpers/api';

import type {
	RejectProfileForNeedResponse,
	RejectProfilesForNeedData,
} from '@/components/modal/Profile/rejectProfile/types';

const rejectProfilesForNeed = async (
	companyNeedId: string,
	data: RejectProfilesForNeedData
): Promise<RejectProfileForNeedResponse> => {
	const response = await api.request<RejectProfileForNeedResponse>({
		url: `/besoins/${companyNeedId}/workers/reject`,
		method: 'POST',
		data,
	});
	return response.data;
};

export default {
	rejectProfilesForNeed,
};
